import React from 'react';
import { Duration } from 'luxon';

import makeStyles from '@mui/styles/makeStyles';

import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'inline',
    flexWrap: 'wrap',
  },
  textField: {
    width: '114px',
  },
}));

/*
 * call with something like
 * <LabeledTimePicker
 *   label="Time of day"
 *   value={<a Luxon Duration>}
 *   onChange={}
 * />
 */
export default function LabeledTimePicker({ label, value, onChange }) {
  const classes = useStyles();

  const handleChange = (event) => {
    const newValue = event.target.value;
    // it's a string like 'hh:mm' in 24-hour notation
    const parts = newValue.split(':');
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const duration = Duration.fromObject({ hours: hours, minutes: minutes });
    onChange(duration);
  };

  return (
    <form className={classes.container} noValidate>
      <TextField
        variant="standard"
        id={label + '-time'}
        label={label}
        type="time"
        value={value.toFormat('hh:mm')}
        onChange={(event) => handleChange(event)}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300, // 5 min
        }}
      />
    </form>
  );
}
